import { render, staticRenderFns } from "./Spirituosen.vue?vue&type=template&id=0dd2ac76&scoped=true"
import script from "./Spirituosen.vue?vue&type=script&lang=js"
export * from "./Spirituosen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2ac76",
  null
  
)

export default component.exports